import React, { useEffect, useState } from "react";
import VerifyNumberAbha from "./verify-number-abha";
import { AlreadyAbhaVerifyNumber, EncryptDataABDM } from "../../services";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setResentCount } from "../../redux/slices/abhaSlice";

const AbhaNumberDetails = ({ setResMessage, resMessage, handleBack }) => {
  const [verifyNumberAbha, setVerifyNumberAbha] = useState(false);
  const [consent, setConsent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [abhaDetails, setAbhaDetails] = useState(null);
  const [selectedAbha, setSelectedAbha] = useState(null);

  const resendCount = useSelector((state) => state.user.resentCount);
  const dispatch = useDispatch();

  useEffect(() => {
    const storedAbhaDetails = localStorage.getItem("abhaDetails");
    if (storedAbhaDetails) {
      try {
        const parsed = JSON.parse(storedAbhaDetails);
        setAbhaDetails(parsed || parsed.abha);
      } catch (err) {
        console.error("Invalid ABHA details in localStorage", err);
      }
    }
  }, []);

  const getAbhaList = () => {
    if (!abhaDetails) return [];
    if (Array.isArray(abhaDetails.abha)) return abhaDetails.abha;
    if (typeof abhaDetails.abha === "object") return [abhaDetails.abha];
    return [];
  };

  const handleCardSelect = (item) => {
    setSelectedAbha(item);
  };

  const handleVerifyNumberAbha = async (e) => {
    e.preventDefault();

    if (!consent) {
      setError("Please accept the consent checkbox.");
      return;
    }

    if (!abhaDetails || !abhaDetails.inputValue) {
      setError("No ABHA details found.");
      return;
    }
    console.log("selectedaaa", selectedAbha);
    if (!selectedAbha) {
      toast.error("Please select an ABHA card.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const encryptedInput = await EncryptDataABDM({
        body: abhaDetails?.inputValue,
      });

      const requestData = {
        scope: ["abha-login", "mobile-verify"],
        loginHint: "mobile",
        loginId: encryptedInput.data,
        otpSystem: "abdm",
        resent_count: resendCount,
      };

      const response = await AlreadyAbhaVerifyNumber({
        headers: {},
        data: requestData,
      });

      if (response?.resent_count !== undefined) {
        dispatch(setResentCount(response.resent_count));
      }

      if (response.success === false) {
        toast.error(response.message || "Failed to send OTP");
        return;
      }
      if (response.success === true) {
        const txnId = response?.data?.txnId;
        if (txnId) localStorage.setItem("txnId", txnId);
        // setsendOtpResponse(true);
        setResMessage(response.message);
        setVerifyNumberAbha(true);
      }
    } catch (err) {
      console.error(err);
      console.log("@@@@@@@@@@@@@@@@@@")
      setError(err?.message || "Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const abhaList = getAbhaList();

  return (
    <>
      {verifyNumberAbha ? (
        <VerifyNumberAbha
          handleBack={() => setVerifyNumberAbha(false)}
          inputType="mobile"
          inputValue={abhaDetails?.inputValue || ""}
          otpType="abdm"
          initialResentCount={resendCount}
          setResMessage={setResMessage}
          resMessage={resMessage}
          selectedAbhaCard={selectedAbha}
        />
      ) : (
        <div className="col-md-6">
          <div className="form-card content">
            <h3 className="custom-h3">ABHA Number / ABHA Address</h3>
            <hr />

            <div className="abha-scroll-container">
              {abhaList.length > 0 ? (
                abhaList.map((item, idx) => (
                  <div
                    key={idx}
                    className={`abha-details-card ${
                      selectedAbha?.ABHANumber === item.ABHANumber
                        ? "selected-card"
                        : ""
                    }`}
                    onClick={() => handleCardSelect(item)}
                  >
                    <p>
                      <strong>Name:</strong> {item.name}
                    </p>
                    <p>
                      <strong>ABHA Number:</strong> {item.ABHANumber}
                    </p>
                    <p>
                      <strong>Gender:</strong> {item.gender}
                    </p>
                    <p>
                      <strong>KYC Verified:</strong>{" "}
                      {item.kycVerified ? "Yes" : "No"}
                    </p>
                  </div>
                ))
              ) : (
                <p>No ABHA records found.</p>
              )}
            </div>

            <div className="checkbox-group">
              <label className="abha-agree-text">
                <input
                  type="checkbox"
                  autoComplete="off"
                  checked={consent}
                  onChange={() => setConsent((v) => !v)}
                />{" "}
                I agree to give my consent to Lal Path Labs to link and update
                my details as per ABHA Address
              </label>
            </div>

            {error && (
              <div className="text-danger pt-2" style={{ fontSize: "14px" }}>
                {error}
              </div>
            )}

            <div className="d-flex gap-2">
              <button className="btn-back2" onClick={handleBack}>
                Back
              </button>
              <button
                className={`continue-btn nha-adhar continue-btn custom-btnmargin ${
                  !consent ? "bg-disable" : ""
                }`}
                onClick={handleVerifyNumberAbha}
                disabled={!consent || loading}
              >
                {loading ? "Linking..." : "Link Now"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AbhaNumberDetails;
